


export const obtainKycStep1 = async (functionParameters={}) => {
    
    const axios = (await import(/* webpackPrefetch: true */ `axios`)).default;

    const { modelPath, smetioPresentationClass,  preloaderClass, smartbox, model, uniqueValues, } = functionParameters;
    
    const apiEndPoint = window.apiEndPoint;
    const language = window.userLanguage;
    // alert("You are about to do KYC");

    preloaderClass.show();

    
    // const url = `${apiEndPoint}/profileDetails/kycModel/${language}/models`;
    const appClass = window.smetioApp;
    const url = `${apiEndPoint}/apps/${appClass.appUserInterface }/profileDetails/model/${language}`;

    const res = await axios.get(url, { params:{ modelPath } }).then(async (response) => {
  
      // console.log("Here is the response from createNewBusinessLocation : ",response );
  
      let model = response.data;
  
      if (model.error) return window.smetioVisitor.showNotification({ type:"danger", body: [{ message: model.msg }] });
  
      const getSlideShowForMultiStepProcess = (await import(/* webpackPrefetch: true */ `../get/getSlideShowForMultiStepProcess.js`)).getSlideShowForMultiStepProcess;
    
      const newVersionOfConvertModelToInputs = (await import(/* webpackPrefetch: true */ `../../classes/universal_methods/newVersionOfConvertModelToInputs.js`)).newVersionOfConvertModelToInputs;
      const setTxtV2= (await import(/* webpackPrefetch: true */ `../../classes/universal_methods/setTxtV2.js`)).setTxtV2;
    
      const {smetioSlideShow} = await getSlideShowForMultiStepProcess({emptyContentOnLeftMove: true});

      functionParameters.preloaderClass = preloaderClass;
      functionParameters.smartbox = smartbox; 
      functionParameters.smetioPresentationClass = smetioPresentationClass;
      functionParameters.smetioSlideShow = smetioSlideShow;
      


    //   let instructionSubtitleText = setTxtV2({ attributes: {}, txt:"txt598", type: "html"});
      const markedFieldText = setTxtV2({ attributes: {}, txt:"txt56", type: "html"});

      const stepText = setTxtV2({ attributes: {}, txt:"txt632", type: "html"}); 
      const instructionSubtitleText = `
        <div class="smetio-margin-top-20">        
            <h6 class="smetio-h6-heading smetio-margin-bottom-20 smetio-text-center">${stepText}: 1 / 3 </h6>
            <p class="smetio-p-text smetio-text-center">${markedFieldText}</p>
        </div>                
      `;
      
      const confirmationInput = await newVersionOfConvertModelToInputs({
        model, 
        withSubmitButton: true, 
        withFullContainerDiv: true,
        submitText: "txt38",
        instructionTitle:"txt598",
        instructionSubtitle:instructionSubtitleText,
        submissionFunctionDetails: {
          functionPath: "kyc/submitKycStep1",
          functionParameters
        }
  
      });
  
      const newPreloaderDisplay = preloaderClass.render();

      const slide_1_content = `
        ${newPreloaderDisplay}
        ${confirmationInput}
      `;
      preloaderClass.hide();
  
      const slideShowItem_1 = {
  
        class: "",
        content: slide_1_content,
        showIcon: false,
        indicator: {
          icon: "thumbs-up",
          text: "",
          isActive:"yes",
          class: ""
        }
  
      };
      const slideShowItem_2 = {
  
        class: "",
        content: ` `,
        showIcon: false,
        indicator: {
          icon: "thumbs-up",
          text: "",
          isActive:"no",
          class: ""
        }
  
      };

      const slideShowItem_3 = {
  
        class: "",
        content: ` `,
        showIcon: false,
        indicator: {
          icon: "thumbs-up",
          text: "",
          isActive:"no",
          class: ""
        }
  
      };

      const slideShowItem_4 = {
  
        class: "",
        content: ` `,
        showIcon: false,
        indicator: {
          icon: "thumbs-up",
          text: "",
          isActive:"no",
          class: ""
        }
  
      };      
     smetioSlideShow.add_items(slideShowItem_1);
     smetioSlideShow.add_items(slideShowItem_2);
     smetioSlideShow.add_items(slideShowItem_3);
     smetioSlideShow.add_items(slideShowItem_4);
  
      const content = smetioSlideShow.render();
  
      smartbox.updateContent(content);
  
  
  
    }).catch((error) => {
  
      console.log(error);
      return window.smetioVisitor.showNotification({type:"danger", body: [{ message: "txt423"}]});
  
    }).finally(() => {
        preloaderClass.hide();
    });

};
